import Price from "../components/Price";
import { ISizeQuantity } from "../interfaces";
import { Grid, List, ListItem, Divider, TextField } from "@mui/material";
import {
  storageTankPriceProvider,
  storageTankGroupProvider,
} from "../providers/storageTankProvider";
import { Fragment } from "react";

interface IProps {
  data: ISizeQuantity[];
}

export default function SummaryStorageTank({ data }: IProps) {
  const groups = storageTankGroupProvider(data);
  const quantity = groups.reduce((acc, curr) => acc + Number(curr.quantity), 0);

  if (groups.length === 0) {
    return <></>;
  }

  return (
    <List>
      {groups.map((group, index) => (
        <Fragment key={index}>
          <ListItem disableGutters>
            <Grid
              container
              spacing={2}
              sx={{ marginRight: 23 }}
              alignItems="center"
            >
              <Grid item xs={3}>
                Mezisoučet #{index + 1}
              </Grid>
              <Grid
                item
                xs={9}
                container
                key={index}
                alignItems="center"
                spacing={2}
              >
                <Grid item xs={5}>
                  <TextField
                    label="Objem (m3)"
                    size="small"
                    value={group.size}
                    fullWidth
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="Celkový počet"
                    size="small"
                    value={group.quantity}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={5}>
                  <Price data={group} provider={storageTankPriceProvider} />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <Divider />
        </Fragment>
      ))}
      <ListItem disableGutters>
        <Grid
          container
          spacing={2}
          sx={{ marginRight: 23 }}
          alignItems="center"
        >
          <Grid item xs={3}>
            Celkový součet
          </Grid>
          <Grid item xs={9} container alignItems="center" spacing={2}>
            <Grid item xs={5}></Grid>
            <Grid item xs={2}>
              <TextField
                label="Celkový počet"
                size="small"
                value={quantity}
                InputProps={{ readOnly: true }}
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={2}>
              <Price
                data={groups}
                isArray={true}
                provider={storageTankPriceProvider}
              />
            </Grid>
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
}
